/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type QrCodeShow_qrCode$ref: FragmentReference;
declare export opaque type QrCodeShow_qrCode$fragmentType: QrCodeShow_qrCode$ref;
export type QrCodeShow_qrCode = {|
  +id: string,
  +createdAt: any,
  +link: string,
  +sign: string,
  +qrCodeUrl: ?string,
  +$refType: QrCodeShow_qrCode$ref,
|};
export type QrCodeShow_qrCode$data = QrCodeShow_qrCode;
export type QrCodeShow_qrCode$key = {
  +$data?: QrCodeShow_qrCode$data,
  +$fragmentRefs: QrCodeShow_qrCode$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QrCodeShow_qrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sign",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "qrCodeUrl",
      "storageKey": null
    }
  ],
  "type": "QrCode"
};
// prettier-ignore
(node/*: any*/).hash = 'd77220b025c75481be17424d2b34b5b1';

module.exports = node;
